/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Nick Cattaneo, Thomas Barry

 Description:
 */
export var FIELD_DEFINE = 'FIELD_DEFINE';
export var FIELD_DELETE = 'FIELD_DELETE';
export var FIELD_RESET = 'FIELD_RESSET';
export var FIELD_APPLY_RESET = 'FIELD_APPLY_RESET';
export var FIELDS_DELETE = 'FIELDS_DELETE';
export var FIELD_CHANGE = 'FIELD_CHANGE';
export var FIELD_APPLY_CHANGE = 'FIELD_APPLY_CHANGE';
export var FIELDS_CHANGE = 'FIELDS_CHANGE';
export var FIELDS_APPLY_CHANGES = 'FIELDS_APPLY_CHANGES';
export var FIELDS_EXECUTE_ONCHANGE_CALLBACKS = 'FIELDS_EXECUTE_ONCHANGE_CALLBACKS';
export var FIELDS_VALIDATE = 'FIELDS_VALIDATE';
export var FIELDS_CLEAR_ERRORS = 'FIELDS_CLEAR_ERRORS';
export var defineField = function defineField(payload) {
  return {
    type: FIELD_DEFINE,
    payload: payload
  };
};
export var deleteField = function deleteField(payload) {
  return {
    type: FIELD_DELETE,
    payload: payload
  };
};
export var resetField = function resetField(payload) {
  return {
    type: FIELD_RESET,
    payload: payload
  };
};
export var applyResetField = function applyResetField(payload) {
  return {
    type: FIELD_APPLY_RESET,
    payload: payload
  };
};
export var deleteFields = function deleteFields(payload) {
  return {
    type: FIELDS_DELETE,
    payload: payload
  };
};
export var changeField = function changeField(payload) {
  return {
    type: FIELD_CHANGE,
    payload: payload
  };
};
export var changeFields = function changeFields(payload) {
  return {
    type: FIELDS_CHANGE,
    payload: payload
  };
};
export var applyFieldChange = function applyFieldChange(payload) {
  return {
    type: FIELD_APPLY_CHANGE,
    payload: payload
  };
};
export var applyFieldChanges = function applyFieldChanges(payload) {
  return {
    type: FIELDS_APPLY_CHANGES,
    payload: payload
  };
};
export var executeOnChangeCallbacks = function executeOnChangeCallbacks(payload) {
  return {
    type: FIELDS_EXECUTE_ONCHANGE_CALLBACKS,
    payload: payload
  };
};
export var validateFields = function validateFields(payload) {
  return {
    type: FIELDS_VALIDATE,
    payload: payload
  };
};
export var clearFieldErrors = function clearFieldErrors(payload) {
  return {
    type: FIELDS_CLEAR_ERRORS,
    payload: payload
  };
};